import axios from '../index'
import qs from 'qs'
/**
 * 加载新闻列表
 * @param {object} pages 分页
 */
export function loadNewsList (pages) {
  return axios.post(
    `/aboutus/load-news-list`,
    qs.stringify({
      page: pages.page,
      limit: pages.limit
    })
  )
}

/**
 * 加载新闻内容
 * @param {number} id id
 */
export function loadNewsContent (id) {
  return axios.post(
    `/aboutus/load-news-content`,
    qs.stringify({
      id
    })
  )
}
/**
 * 加载协议
 * @param {number} id id
 */
export function loadPolicyContent (id) {
  return axios.post(
    `/aboutus/load-policy-content`,
    qs.stringify({
      id
    })
  )
}
